import type { TStatePelaksanaan } from 'types/kinerja-pelaksanaan'

export const PRAKTIK_KINERJA_STEP_ORDER: Array<TStatePelaksanaan> = [
  'DOCUMENT_PREPARATION',
  'OBSERVATION_IMPLEMENTATION',
  'DOCUMENT_FOLLOW_UP',
  'FOLLOW_UP_EVALUATION',
  'DOCUMENT_REFLECTION_FOLLOW_UP',
  'REFLECTION_FOLLOW_UP_EVALUATION',
  'COMPLETED',
]
